import React from 'react';

export default function () {
    return <div id="bnt_app_container">not found</div>;
}
